import script from "./TagListItem.vue?vue&type=script&setup=true&lang=js"
export * from "./TagListItem.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/www/harixx_test/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"TagListItem.vue"]])

export default __exports__